module.exports = __webpack_public_path__ + "static/media/seeds-of-change-desktop.fb974528.jpg";